export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  /* Figma: effects/shadows/shadow-xs (#0a0d12 @ 7%) */
  shadowXs: 'rgba(10, 13, 18, 0.07)',
  type: 'light',
  primary: {
    main: '#32629A',
    light: '#F7F8F8',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: 'rgba(255, 255, 255, 0.2)',
    contrastText: '#22211F',
  },
  text: {
    brand: '#013A59',
    brandAction: '#32629A',
    iconNeutral: '#3E444E',
    iconBrandAlt: '#6CB3E6',
    primary: '#001A11',
    secondary: '#333132',
    tertiaryLight: '#333132',
    tertiary: '#333132',
    alternate: '#7C8694',
    textPrimary: '#25272C',
    planCardSecondary: '#49515B',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    contrastText: '#22211F',
    onDarkSecondary: 'rgba(255, 255, 255, 0.88)',
    onDarkTertiary: 'rgba(255, 255, 255, 0.75)',
    onDarkEmphasis: 'rgba(255, 255, 255, 0.92)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    brandLight: '#0A2E4D',
    heroMobile: '#17467B',
    fill: '#FAFAFA',
    hero1: '#002015B2',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#071B32',
    level2: '#f7f8fb',
    level1: 'rgba(255, 255, 255, 0.12)',
    brandAccent: '#3A96CE',
    tableHead: '#3A96CE',
    tableSubhead: 'rgba(234, 244, 251, 0.6)',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B6BFA5',
    secondary: '#F5F3F0',
    light: '#EDEDED',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#2563BA',
    ribbon: '#BBE6FE',
    offer: '#D7FFF7',
    stepperCompleted: '#081425',
    border: '#D7DBE0',
    dark:'#32629A',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    /** Pricing & benefits — dark concentrated ~top-left 25%, then lighter to bottom-right */
    pricing:
      'linear-gradient(180deg, #35659C 0%, #7397B6 100%)',
    learnMore: '#F4F4F4',
    header: '#FAFAFA',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
